import React from 'react';

import { useDataType } from '../../../../statspro/js/components/common/hooks/use-data-type';
import { DATA_TYPE } from '../../../../statspro/js/components/common/config/data-type';
import { composeGetTranslation } from '../../../../../../common/react/utils/translations';
import { ToggleInput } from '../../../..//../../common/react/components/ToggleInput';
import { useSelector } from 'react-redux';
import { playerStatsDataTypeSelector } from '../../../../store/js/modules/match-centre/player-stats/selectors';
import { UPDATE_DATA_TYPE } from '../../../../store/js/modules/match-centre/player-stats/actions';

export const DataTypeToggle = () => {
    const initialDataType = useSelector(playerStatsDataTypeSelector);

    const { dataType, updateDataType } = useDataType({
        initialDataType,
        onUpdateActionCreator: UPDATE_DATA_TYPE.request
    });

    const getTranslation = composeGetTranslation(
        'label.statsLeaders.dataType.'
    );

    return (
        <ToggleInput
            id="careers-and-season-stats-data-type-toggle"
            value={
                dataType.type.toLowerCase().includes(DATA_TYPE.TOTALS)
                    ? DATA_TYPE.TOTALS
                    : DATA_TYPE.AVERAGES
            }
            onChange={updateDataType}
            options={[
                {
                    label: getTranslation(DATA_TYPE.MATCH),
                    value: DATA_TYPE.TOTALS
                },
                {
                    label: getTranslation(DATA_TYPE.SEASON_AVERAGES),
                    value: DATA_TYPE.AVERAGES
                }
            ]}
        />
    );
};
